import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="https://customer-assets-jai6qajn.emergentagent.net/job_transition-homes-2/artifacts/0wzphmur_New%20Level%20Logo%20Design.png"
              alt="New Level Transition Homes"
              className="footer-logo"
            />
            <p className="footer-tagline">
              Providing safe, affordable, structured housing and a supportive
              community to help individuals rebuild their lives.
            </p>
          </motion.div>

          <motion.div
            className="footer-contact"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4>Contact Us</h4>
            <div className="contact-items">
              <a href="tel:832-419-4816" className="contact-item">
                <Phone size={20} />
                <span>832-419-4816</span>
              </a>
              <a href="mailto:newleveltransition@Gmail.com" className="contact-item">
                <Mail size={20} />
                <span>newleveltransition@Gmail.com</span>
              </a>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p>&copy; {new Date().getFullYear()} New Level Transition Homes. All rights reserved.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
